import React from 'react';
import { MapPinIcon } from 'lucide-react';
import { reviews } from '../data/reviews';

/** Reseñas de compradores. No se muestra mientras data/reviews.ts esté vacío. */
export function Reviews() {
  if (reviews.length === 0) return null;
  return <section aria-labelledby="reviews-heading" className="topo-light w-full bg-paper text-pine" data-id="element-351" data-mp="2madvo0nuc6ws">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:py-20" data-id="element-352" data-mp="2r8feqll9o689">
        <div className="text-center" data-id="element-353" data-mp="2w93fhyzas1fo">
          <p className="eyebrow text-ember-deep" data-id="element-354" data-mp="2w820jjf5uuso">From the field</p>
          <h2 id="reviews-heading" className="trail-underline mt-3 font-display text-[34px] leading-tight text-pine sm:text-6xl" data-id="element-355" data-mp="309x46ukkdk9m">
            What techs are seeing on their calls
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-pine-soft" data-id="element-356" data-mp="3a3443zwjc82b">
            Solar technicians and installers using Solar PV &amp; Battery
            Diagnostic Pro on real service calls.
          </p>
        </div>

        <ul className="mt-10 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-357" data-mp="2rd6z07xn04pr">
          {reviews.map(review => <li key={review.name} className="flex" data-id="element-358" data-mp="2mcjbhw8ma60a">
              <figure className="flex w-full flex-col border-t-2 border-ember pt-5" data-id="element-359" data-mp="2hehqv6vjlymp">
                <blockquote className="text-[17px] leading-relaxed text-pine" data-id="element-360" data-mp="2hgkghpss9pqw">
                  “{review.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-361" data-mp="3a3evi76tzwwz">
                  <span aria-hidden="true" className="flex h-10 w-10 flex-none items-center justify-center rounded-full bg-forest font-display text-base text-paper" data-id="element-362" data-mp="354c25k07rf4u">
                    {initials(review.name)}
                  </span>
                  <span className="min-w-0 text-xs text-pine-soft" data-id="element-363" data-mp="3stmxglysohbl">
                    <span className="block text-[14px] font-bold text-pine" data-id="element-364" data-mp="3suy0ukobvn26">
                      {review.name}
                    </span>
                    {review.role}
                    <span className="mt-0.5 flex items-center gap-1 text-pine-muted" data-id="element-365" data-mp="1m6p8evw5xj4i">
                      <MapPinIcon className="h-3 w-3 flex-none" aria-hidden="true" data-id="element-366" data-mp="1r3fmjdoeq4na" />
                      {review.city}, {review.country}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}
function initials(name: string) {
  return name.split(' ').map(part => part[0]).join('').slice(0, 2);
}